import { Module } from 'vuex';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { state, IUploadState } from './state';

export const NAME = 'upload';
export const store: Module<IUploadState, IRootState> = {
    actions,
    getters,
    mutations,
    namespaced: true,
    state
};

export default store;
